// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3EHT-","colMin":"styles_colMin__2i7hB","colCheckbox":"styles_colCheckbox__1yiP-"};